import { v4 as uuidv4 } from "uuid";
export class PMOProjectModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.description = "";
        this.createdOnAsString = "";
        this.createdBy = uuidv4();
        this.modifiedOn = null;
        this.modifiedOnAsString = "";
        this.modifiedBy = null;
        this.deletedOn = null;
        this.deletedOnAsString = "";
        this.deletedBy = null;
        this.isAddSubProject = false;
        this.isAlreadyRequested = false;
        this.isAccessForParentProject = false;
        this.isLinked = false;
        this.tasks = [];
        this.members = [];
        this.timeSpent = 0;
        this.isWatching = false;
        this.isEditable = false;
        this.unResolvedImpediment = 0;
    }
}
export default class PMOProject extends PMOProjectModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
